const Cookie = process.client ? require('js-cookie') : undefined;

export const state = () => ({
  redemptionCode: null,
  pendingCodeId: null,
});

export const getters = {
  redemptionCode: (state) => state.redemptionCode,
};

export const actions = {
  async fetchRedemptionCode({ commit, rootState }, codeId) {
    if (!codeId || typeof codeId !== 'string' || !rootState?.store?._id) {
      return;
    }
    try {
      const data = await this.$api.codes.getDiscountById(rootState.store._id, codeId);
      if (data) {
        commit('SET_REDEMPTION_CODE', data);
      }
    } catch (e) {
      console.error('Error fetching redemption code:', e);
    }
  },

  async initializeRedemptionCode({ state, dispatch, commit }) {
    if (state.pendingCodeId) {
      await dispatch('fetchRedemptionCode', state.pendingCodeId);
      commit('SET_PENDING_CODE_ID', null);
    }
  },

  clearRedemptionCode({ commit }) {
    Cookie.remove('REDEMPTION_CODE_ID');
    commit('SET_REDEMPTION_CODE', null);
    commit('SET_PENDING_CODE_ID', null);
  },
};

export const mutations = {
  SET_REDEMPTION_CODE(state, code) {
    state.redemptionCode = code;
  },
  SET_PENDING_CODE_ID(state, codeId) {
    state.pendingCodeId = codeId;
  },
};
